// Social media links
export const socialMedia = {
  instagram: 'https://www.instagram.com/adv_imran_pathan_9536102?igsh=MWpuMjNtbG94bXFqMw==',
  linkedin: 'https://www.linkedin.com/in/advocate-imran-pathan-8728202b7',
  twitter: 'https://twitter.com/imran8307534087',
  facebook: 'https://www.facebook.com/share/17o9q7QEqu/',
  youtube: 'https://youtube.com/@advocateimranpathanaligarh?si=DOEJUp-Fs_SPp6rj'
};
